import React, { useState } from 'react';

import { Icon } from '../../../../../../components/Icon';
import { colors } from '../../../../../../styles/tokens';

import { Container, DangerButton, Title, ToolButton } from './styles';

interface QuickToolsProps {
  hasExercises: boolean;
  onReset: () => Promise<void>;
  onSuggestTraining: () => void;
  hasTrainingSuggestionFeature: boolean;
  onSelectTemplate: () => void;
  hasTrainingTemplatesFeature: boolean;
  onPrint: () => void;
  preparingPrint: boolean;
}

const QuickTools: React.FC<QuickToolsProps> = ({
  hasExercises,
  onReset,
  onSuggestTraining,
  hasTrainingSuggestionFeature,
  onSelectTemplate,
  hasTrainingTemplatesFeature,
  onPrint,
  preparingPrint,
}) => {
  const [resetting, setResetting] = useState(false);

  const handleReset = async () => {
    setResetting(true);
    await onReset();
    setResetting(false);
  };

  return (
    <Container>
      <Title>Ferramentas rápidas</Title>

      <ToolButton
        type="button"
        disabled={!hasTrainingSuggestionFeature}
        title={
          hasTrainingSuggestionFeature
            ? undefined
            : 'Sugestão automática de treino é um recurso sob solicitação. Entre em contato para ativar.'
        }
        onClick={onSuggestTraining}
      >
        <span>Sugerir treino</span>
        <Icon
          name={hasTrainingSuggestionFeature ? 'auto_awesome' : 'lock'}
          size={18}
          color={colors.onSurfaceVariant}
        />
      </ToolButton>

      <ToolButton
        type="button"
        disabled={!hasTrainingTemplatesFeature}
        title={
          hasTrainingTemplatesFeature
            ? undefined
            : 'Templates de treino é um recurso sob solicitação. Entre em contato para ativar.'
        }
        onClick={onSelectTemplate}
      >
        <span>Selecionar template</span>
        <Icon
          name={hasTrainingTemplatesFeature ? 'assignment_turned_in' : 'lock'}
          size={18}
          color={colors.onSurfaceVariant}
        />
      </ToolButton>

      <ToolButton type="button" disabled={preparingPrint} onClick={onPrint}>
        <span>{preparingPrint ? 'Preparando...' : 'Imprimir ficha'}</span>
        <Icon name="print" size={18} color={colors.onSurfaceVariant} />
      </ToolButton>

      <DangerButton
        type="button"
        disabled={!hasExercises || resetting}
        onClick={handleReset}
      >
        <span>{resetting ? 'Reiniciando...' : 'Reiniciar este dia'}</span>
        <Icon name="restart_alt" size={18} color="currentColor" />
      </DangerButton>
    </Container>
  );
};

export { QuickTools };
